import { Assets } from '../Assets';
import { WebfontFile } from '../loaders/WebfontFile';
import { SceneKeys } from '../SceneKeys';
import { AdHelper } from '../sdk/AdHelper';
import { BaseScene } from './BaseScene';

export class BootScene extends BaseScene {

    constructor() {
        super("BootScene");
    }

    preload() {
        AdHelper.init();

        this.loadAtlas(Assets.ATLAS_LOADER);
        this.load.addFile(new WebfontFile(this.load, "google", ["Poppins"]));
    }

    loadAtlas(asset: { key: string, imageUrl: string, jsonUrl: string }) {
        this.load.atlas(asset.key, asset.imageUrl, asset.jsonUrl);
    }

    async create() {

        const c = await import('./Preloader');
        this.scene.add(SceneKeys.PRELOADER, c.PreloaderScene, false);
        this.scene.start(SceneKeys.PRELOADER);
    }

}